import { render } from "./DanhMucVatTuTable.vue?vue&type=template&id=445a7b3a&ts=true"
import script from "./DanhMucVatTuTable.vue?vue&type=script&lang=ts"
export * from "./DanhMucVatTuTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__